<template>
  <div id="ProductDetailPage">
    <NavBar class="overflow-y-hidden"/>

    <!--    <div  class="row">-->
    <!--      <div class="col-12 col-md-8 col-lg-6 ">-->
    <v-main v-if="isContentLoaded" class="overflow-hidden ">
      <!--      <div v-if="isChartLoaded">-->
      <!--        <PlanetChart  :chart-data="log()" :chart-max="maxPrice"-->
      <!--                      :chart-min="minPrice" :chartLabel="log2()"/>-->
      <!--      </div>-->
      <v-stepper v-model="productInfoStepper" class="pb-md-0 mb-md-2 ">
        <v-stepper-header>
        </v-stepper-header>
        <v-stepper-items>
          <v-stepper-content class="px-0 has-footer-productDetail" step="1">
            <div class="container-fluid">
              <div class="row align-items-center">
                <div class="col-2 py-0 pl-0 pr-1">
                  <v-btn icon @click="$router.go(-1)">
                    <i class="fa-solid fa-arrow-right fa-xl"></i></v-btn>
                </div>
                <div class="col-10 py-0 pl-0  text-left justify-content-end d-flex text-left">
                  <div class="ml-2" dir="ltr">
                    <span v-for="(item,index) in breadCrumbItems" :key="item.id"><router-link
                        :to="{path: 'ProductsList', query: {ProductCategoryID: item.id,Name: item.name}}"
                        class="primary-text">
          {{ item.name }}</router-link><i
                        v-if="breadCrumbItems.length !== (index+1)"
                        class="fas fa-caret-right  font-weight-bold px-2 font19px transform-icon"></i> </span>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-12 py-0">
                  <div class="row align-items-center">
                    <router-link :to="{path:'StoreProfile',query:{VendorID:productDetail.VendorID}}" class="col-8">
                      <v-avatar>
                        <img :src="$replaceHttps(productDetail.ProductCategorFileUrl)" alt="لوگو فروشگاه">
                      </v-avatar>
                      <span class="mr-2 font16px">{{ productDetail.VendorName }}</span>
                    </router-link>
                    <div class="col-4 text-left pl-0">

                      <span> <i class="fa-solid fa-star yellow--text ml-1"></i>{{ vendorRates }}</span>
                      <v-btn class="pl-1" icon @click="openReportSheet = !openReportSheet"><i
                          class="fa-regular fa-ellipsis-vertical font24px  primary-text"></i></v-btn>
                    </div>
                  </div>
                </div>
                <div v-if="gallery.length >0" class="col-12  p-0 ">
                  <v-carousel
                      :continuous="false"
                      :cycle="true"
                      :show-arrows="false"
                      class="carousel-dots banner-carousel"
                      dark
                      delimiter-icon="fa-solid fa-circle-small white--text"
                      height="380"
                      hide-delimiter-background>
                    <v-carousel-item
                        v-for="(slide, i) in gallery"
                        :key="i">
                      <VideoPlayer v-if="slide.TypeStrucGallery ===2" :videoSrc="slide.FileUrl" height="380"/>
                      <v-img v-else :src="$replaceHttps(slide.FileUrl)" class="col-12 bg-black" contain
                             height="380">
                      </v-img>
                    </v-carousel-item>
                    <div class="d-flex align-items-end flex-column  position-absolute actions-on-product-detail ">
                      <div class="mt-2"><span class="product-card-bookmark rounded-circle pointer mx-auto"
                                              @click.stop.prevent="setBookMark"><i
                          :class="productBookmarkActive ? 'red--text fa-solid fa-bookmark' :'fa-light fa-bookmark'"
                          class=" fa-lg white--text"></i></span>
                      </div>
                      <div class="my-2"><span class="product-card-bookmark rounded-circle pointer mx-auto"
                                              @click.stop.prevent=openSendComments><i
                          :class="commentsActive ? 'red--text fa-solid fa-comments' :'fa-light fa-comments'"
                          class=" fa-lg white--text"></i></span>
                      </div>

                      <div><span class="product-card-bookmark rounded-circle pointer mx-auto"
                                 @click.stop.prevent="openChartSheet"><i
                          :class="chartActive ? 'red--text fa-solid fa-chart-line-up' :'fa-light fa-chart-line-up'"
                          class=" fa-lg white--text"></i></span>
                      </div>
                      <div class="mt-2"><span class="product-card-bookmark rounded-circle pointer mx-auto"
                                              @click="copy('https://eyvankhaneh.app/SearchEngine/SpecialProduct?VendorProductID=' + productDetail.VendorProductID)">
              <i class="fa-solid fa-paper-plane fa-lg white--text"></i></span>
                      </div>

                    </div>
                  </v-carousel>
                </div>
                <div class="col-12 ">
                  <h1 class="primary-text mb-3">{{ productDetail.Name }}</h1>
                  <div class="row ">
                    <div class="col-6  p-2">
                      <div class="row ">
                        <div class="col-12">
                          <span class="d-inline-block w-50 ">واحد محصول:</span>
                          <span class="d-inline-block w-50 text-left">{{ productDetail.ProductUnitName }}</span>
                        </div>
                        <div class="col-12">
                          <span class="d-inline-block w-75 ">زمان تحویل محصول:</span>
                          <span class="d-inline-block w-25 text-left">{{ productDetail.DayDeliver }}</span>
                        </div>
                        <div class="col-12">
                          <span class="d-inline-block w-50 ">کد محصول :</span>
                          <span class="d-inline-block w-50 text-left">{{ productDetail.Code }}</span>
                        </div>
                        <div class="col-12 mt-7 py-0">
                          <v-select
                              v-model="select"
                              :items="selectTips"
                              :menu-props="{ down: true, offsetY: true }"
                              dense
                              flat
                              hide-details
                              solo
                              @change="selectedTip">

                          </v-select>
                        </div>
                      </div>
                    </div>
                    <div class="col-6  p-2">
                      <v-img :src="$replaceHttps(productTip.FileUrl)" class="rounded-lg" height="200">

                      </v-img>
                    </div>
                    <div class="col-12  ">
                      <div id="productDetails" class="row">
                        <div class="col-12">
                          <span>رنگ محصول:</span>
                          <span class="text-color float-left">{{ productTip.Color }}</span>
                        </div>
                        <div class="col-12">
                          <span>کد HEX رنگ محصول:</span>
                          <span class="text-color float-left"><span
                              :style="'background-color:'+ productTip.ColorHex"
                              class="hex-color-circle rounded-circle"></span></span>
                        </div>
                        <div class="col-12">
                          <span>سایز محصول:</span>
                          <span class="text-color float-left">{{ productTip.Size }}</span>
                        </div>
                        <div class="col-12">
                          <span>درجه کیفی: </span>
                          <span class="text-color float-left">{{ productTip.Quality }}</span>
                        </div>
                        <div class="col-12">
                          <span>نوع محصول:</span>
                          <span class="text-color float-left">{{ productTip.Type }}</span>
                        </div>
                        <div class="col-12">
                          <span>مقدار موجودی بر حسب واحد:</span>
                          <span class="text-color float-left">{{ productTip.CountAvilable }}</span>
                        </div>
                      </div>
                    </div>
                    <div class="col-12   px-0 ">
                      <div
                          class="col-12 d-flex justify-space-between pointer light-gray-border-bottom light-gray-border-top"
                          @click="productInfoStepper = 2">
                        <div class="third-text">توضیح محصول</div>
                        <div><i class="fa-solid fa-angle-left"></i></div>
                      </div>
                      <div class="col-12 d-flex justify-space-between pointer light-gray-border-bottom "
                           @click="productInfoStepper = 3">
                        <div class="third-text">مشخصات فنی</div>
                        <div><i class="fa-solid fa-angle-left"></i></div>
                      </div>
                      <div class="col-12 d-flex justify-space-between pointer light-gray-border-bottom "
                           @click="productInfoStepper = 4">
                        <div class="third-text">نقد و بررسی</div>
                        <div><i class="fa-solid fa-angle-left"></i></div>
                      </div>
                      <div class="col-12 d-flex justify-space-between pointer light-gray-border-bottom "
                           @click="productInfoStepper =5">
                        <div class="third-text">نظرات کاربران</div>
                        <div><i class="fa-solid fa-angle-left"></i></div>
                      </div>
                    </div>
                    <div class="col-12 ">
                      <div v-if="productTip.Price !== 0" class="row  bg-white rounded-lg fix-to-bottom">
                        <div class="col-12 text-center">
                          افزودن به سبد خرید
                        </div>
                        <div class="col-7 px-1">
                          <v-text-field
                              v-model="orderNumber"
                              append-icon="fa-solid fa-minus"
                              append-outer-icon="fa-light fa-trash-can"
                              class="rounded-lg px-0 order-input-field "
                              dense
                              flat
                              hide-details
                              prepend-inner-icon="fa-solid fa-plus "
                              solo
                              prepend-icon="fa-solid fa-cart-circle-plus"
                              @click:prepend="setOrder(productTip.VendorProductTipID,orderNumber)"
                              @click:append-outer="removeFromCart(productTip.VendorProductTipID)"
                              @click:append="minusOrder(productTip.VendorProductTipID)"
                              @click:prepend-inner="addOrder(productTip.VendorProductTipID)"
                          ></v-text-field>
                        </div>
                        <div class="col-5 pr-0">
                          <div class="d-flex justify-space-between">
                      <span v-if="productTip.Discount !== 0" class="product-card-discount rounded-circle m-0">
        {{ productTip.Discount }} %</span> <span
                              class="text-color text-decoration-line-through font14px">
                            {{ $numberWithCommas(productTip.Price) }}</span>
                          </div>
                          <div></div>
                          <div class="text-left primary-text">
                            {{ $computingPriceOffer(productTip.Price, productTip.Discount) }} تومان
                          </div>
                        </div>

                      </div>
                      <div v-else class="row  bg-white rounded-lg fix-to-bottom">
                        <div class="col-12">
                          <div class="primary-bg p-3 rounded-lg white--text text-center">
                            برای اطلاع از قیمت تماس بگیرید

                          </div>
                        </div>
                      </div>


                    </div>
                  </div>
                </div>
                <ProductListCardCarousel :dataLoading="similarProductsLoading" :products="similarProducts"
                                         :title="'محصولات مشابه'"/>
                <ProductListCardCarousel :dataLoading="lastSeenLoading" :products="lastSeen" :title="'آخرین مشاهده ها'"
                                         class="my-4"/>

              </div>
              <v-bottom-sheet v-model="openSendCommentSheet">
                <v-sheet
                    class="rounded-t-xl ">
                  <div class="row align-items-center">
                    <div class="col-auto font-weight-bold pr-8 primary-text">
                      نظر خود را بنویسید
                    </div>

                    <div class="col text-left  pl-6">
                      <v-btn
                          icon
                          @click="closeCommentsSheet">

           <span class="fa-stack  font16px bottom-sheet">
             <i class="fa-solid fa-clock-seven fa-stack-2x black--text"></i>
             <i class="fa-solid fa-circle-xmark fa-stack-1x fa-inverse white--text"></i>
           </span>
                      </v-btn>
                    </div>
                  </div>
                  <div class="row mx-1">
                    <div class="col-12 ">
                      <v-textarea
                          v-model="commentDescription"
                          auto-grow
                          background-color="secondary"
                          flat
                          full-width
                          hide-details
                          placeholder="این محتوا ..."
                          rows="4"
                          solo>
                      </v-textarea>
                    </div>
                    <div class="col-3 pl-0">
                      امتیاز دهید
                    </div>
                    <div class="col-7 pr-0">
                      <v-rating
                          v-model="rate"
                          background-color="black"
                          color="yellow"
                          dense
                          length="10"
                          size="22"
                      ></v-rating>
                    </div>
                    <div class="col-12 text-left pt-0">
                      <v-btn class="pl-1 pb-1" icon @click="registerComment">
                        <i class="fa-solid fa-square-check fa-3x black--text"></i>
                      </v-btn>
                    </div>
                  </div>
                </v-sheet>
              </v-bottom-sheet>
            </div>
          </v-stepper-content>
          <v-stepper-content class="p-1 pt-0" step="2">
            <div class="row">
              <div class="col-12 py-0 pr-1">
                <v-btn icon>
                  <i class="fa-solid fa-arrow-right fa-xl pointer"
                     @click="productInfoStepper = 1"></i></v-btn>
              </div>
              <div class="col-12  ">
                <div class="row">

                  <div class="col-4"><img :src="$replaceHttps(productDetail.FileUrl)" alt="تصویر محصول"
                                          class="img-fluid rounded-lg">
                  </div>
                  <div class="col-4 align-self-end pr-1">توضیح محصول</div>
                  <div class="col-12">
                    <div class="bg-white rounded-lg p-2" v-html="productDetail.Description">

                    </div>
                  </div>
                </div>
              </div>
            </div>
          </v-stepper-content>
          <v-stepper-content class="p-1 pt-0" step="3">
            <div class="row">
              <div class="col-12 py-0 pr-1">
                <v-btn icon>
                  <i class="fa-solid fa-arrow-right fa-xl pointer"
                     @click="productInfoStepper = 1"></i></v-btn>
              </div>
              <div class="col-12  ">
                <div class="row ">

                  <div class="col-4"><img :src="$replaceHttps(productDetail.FileUrl)" alt="تصویر محصول"
                                          class="img-fluid rounded-lg">
                  </div>
                  <div class="col-4 align-self-end pr-1">مشخصات فنی</div>
                  <div v-for="(item,i) in productInfo" :key="i" class="col-12 p-1">
                    <div class="bg-white rounded-lg row">
                      <div class="col-6 pr-8">{{ item.Name }}</div>
                      <div v-if="item.TypeProductCategoryDetail ===1" class="col-6 text-center">
                        <span v-if="item.Value === 'true'">بله</span>
                        <span v-else>خیر</span>
                        <span></span>
                      </div>
                      <div v-else class="col-6 text-center">
                        {{ item.Value }}
                      </div>

                    </div>
                  </div>

                </div>
              </div>
            </div>
          </v-stepper-content>
          <v-stepper-content class="p-1 pt-0" step="4">
            <div class="row">
              <div class="col-12 py-0 pr-1">
                <v-btn icon>
                  <i class="fa-solid fa-arrow-right fa-xl pointer"
                     @click="productInfoStepper = 1"></i></v-btn>
              </div>
              <div class="col-12  ">
                <div class="row">

                  <div class="col-4"><img :src="$replaceHttps(productDetail.FileUrl)" alt="تصویر محصول"
                                          class="img-fluid rounded-lg">
                  </div>
                  <div class="col-4 align-self-end pr-1">نقد و بررسی</div>
                  <div class="col-12">
                    <div class="bg-white rounded-lg p-2" v-html="productDetail.ProductReview">

                    </div>
                  </div>
                </div>
              </div>
            </div>
          </v-stepper-content>
          <v-stepper-content class="p-1 pt-0" step="5">
            <div class="row">
              <div class="col-12 py-0 pr-1">
                <v-btn icon>
                  <i class="fa-solid fa-arrow-right fa-xl pointer"
                     @click="productInfoStepper = 1"></i></v-btn>
              </div>
              <div class="col-12">
                <div class="row">

                  <div class="col-4"><img :src="$replaceHttps(productDetail.FileUrl)" alt="تصویر محصول"
                                          class="img-fluid rounded-lg">
                  </div>
                  <div class="col-4 align-self-end pr-1 mt-7">نظرات کاربران</div>
                  <div v-if="comments.length <= 0" class="col-12  text-center">
                    <div><i class="fa-light fa-face-frown-slight fa-3x grey--text"></i></div>
                    <div class="mt-2">
                      هنوز نظری ثبت نشده است
                    </div>

                  </div>
                  <div v-if="comments.length >0" class="col-12 p-4">
                    <div v-for="(item,i) in comments" :key="i" class="row ">
                      <div class="col-9 forth-bg rounded-lg pl-1" @click="goToCommentOwner(item)">
                        <v-avatar size="38">
                          <img v-if="item.AppUserUrl !== null" :src="$replaceHttps(item.AppUserUrl)"
                               alt="تصویر کاربر">
                          <i v-else class="fas fa-circle-user fa-3x"></i>

                        </v-avatar>
                        <span class="font-weight-bold mr-1 d-inline-block" dir="ltr">: {{ item.AppUserName }} </span>
                        <span class="font-weight-normal">{{ item.Description }}</span>
                      </div>
                      <div class="col-3 text-left">
                        <div>{{ $convertDate(item.ModifiedDate) }}</div>
                        <div>{{ item.Rate }} <i class="fa-solid fa-star yellow--text"></i></div>
                      </div>
                      <div class="col-12">
                        <div v-if="item.AnswerDescription !== null" class="row">
                          <div class="col-1"><i class="fa-solid fa-arrow-turn-down-left fa-lg"></i></div>
                          <div class="col-8 forth-bg rounded-lg pb-0" @click="goToCommentReplyProfile()">
                            <v-avatar size="38">
                              <img :src="$replaceHttps(item.VendroPictureUrl)" alt="تصویر پاسخ دهنده">
                            </v-avatar>
                            <span class="font-weight-bold mr-1">{{ item.VendorName }} :</span>
                            <span class="font-weight-normal">{{ item.AnswerDescription }}</span>
                          </div>
                          <div class="col-3 text-left pb-0 reply-comments-action pr-0">
                            <div v-if="item.AnswerDate !== null">{{ $convertDate(item.AnswerDate) }}</div>
                            <div>{{ item.CountLike }}
                              <v-btn icon small @click="like(item.VoteID)"><i
                                  class="fa-solid fa-thumbs-up fa-xl  green--text"></i></v-btn>
                            </div>
                            <div>{{ item.CountDislike }}
                              <v-btn icon small @click="dislike(item.VoteID)"><i
                                  class="fa-solid fa-thumbs-down fa-xl  red--text"></i></v-btn>
                            </div>
                          </div>
                        </div>
                      </div>

                    </div>
                  </div>
                </div>
              </div>
            </div>
          </v-stepper-content>


        </v-stepper-items>
        <v-bottom-sheet v-model="openReportSheet">
          <v-sheet
              class="rounded-t-xl ">
            <div class="row align-items-center">
              <div class="col-auto font-weight-bold pr-8">
                مشکل در کدام بخش است؟
              </div>
              <div class="col text-left  pl-6">
                <v-btn
                    icon
                    @click="openReportSheet = !openReportSheet">
           <span class="fa-stack  font16px bottom-sheet">
             <i class="fa-solid fa-clock-seven fa-stack-2x black--text"></i>
             <i class="fa-solid fa-circle-xmark fa-stack-1x fa-inverse white--text"></i>
           </span>
                </v-btn>
              </div>
            </div>
            <div class="row mx-1">
              <div class="col-12 pt-0">
                <v-radio-group v-model="radioGroup" hide-details>
                  <v-radio
                      label="کلاهبرداری و نقض قانون یا وقوع جرم"
                      value="کلاهبرداری و نقض قانون یا وقوع جرم"
                  ></v-radio>
                  <v-radio
                      label="محتوای آگهی"
                      value="محتوای آگهی"
                  ></v-radio>
                  <v-radio
                      label="مشکلات صاحب آگهی"
                      value="مشکلات صاحب آگهی"
                  ></v-radio>
                  <div class="row">
                    <div class="col-2">
                      <v-radio
                          :value="reportDescription"
                          label="سایر"
                          @change="otherReport = true"
                      ></v-radio>
                    </div>
                    <div class="col-8 pl-0">
                      <v-textarea
                          v-model="reportDescription"
                          :disabled="!otherReport"
                          auto-grow
                          background-color="secondary"
                          flat
                          full-width
                          hide-details
                          placeholder="این محتوا ..."
                          rows="4"
                          solo>
                      </v-textarea>
                    </div>
                    <div class="col-2 align-self-end ">
                      <v-btn class="pl-1 pb-1" icon @click="reportProduct">
                        <i class="fa-solid fa-square-check fa-3x black--text"></i>
                      </v-btn>
                    </div>
                  </div>


                </v-radio-group>
              </div>

            </div>

          </v-sheet>
        </v-bottom-sheet>

      </v-stepper>

    </v-main>
    <!--      </div>-->

    <!--    </div>-->
    <v-overlay :value="showLoaderDialog">
      <div class="loading-spinner">
      </div>
    </v-overlay>
    <v-snackbar
        v-model="showResult"
        :multi-line="true"
        color="primary">
      {{ resultText }}

      <template v-slot:action="{ attrs }">
        <v-btn v-bind="attrs" icon @click="showResult = false ">
          <i class="fa-solid fa-circle-xmark fa-xl white--text"></i>
        </v-btn>
      </template>
    </v-snackbar>
    <v-bottom-sheet v-model="showChartModal">
      <v-sheet
          class="rounded-t-xl ">
        <div class="row align-items-center">
          <div class="col-auto font-weight-bold pr-8">
            نمودار قیمت
          </div>
          <div class="col text-left  pl-6">
            <v-btn
                icon
                @click="showChartModal = !showChartModal">
           <span class="fa-stack  font16px bottom-sheet">
             <i class="fa-solid fa-clock-seven fa-stack-2x black--text"></i>
             <i class="fa-solid fa-circle-xmark fa-stack-1x fa-inverse white--text"></i>
           </span>
            </v-btn>
          </div>
        </div>
          <div>
            <PlanetChart v-if="isChartLoaded" :chart-data="log()" :chart-max="maxPrice"
                         :chart-min="minPrice" :chartLabel="log2()"/>
          </div>
      </v-sheet>
    </v-bottom-sheet>
    <!--    <v-dialog
            v-model="showChartModal"
            hide-overlay
            scrollable>
          <v-card class="p-3 dialog-background-color ">
            <p class="primary-text text-center font-weight-bold font4w m-0 gold-border-bottom mb-5">نمودار قیمت</p>
            <v-card-text class="p-0 my-5">
              <div>
                <div>
                  <PlanetChart v-if="isChartLoaded" :chart-data="log()" :chart-max="maxPrice"
                               :chart-min="minPrice" :chartLabel="log2()"/>
                </div>
              </div>
            </v-card-text>
            <v-card-actions class="px-0">

            </v-card-actions>
          </v-card>
        </v-dialog>-->

  </div>
</template>

<script>
import ProductListCardCarousel from "@/components/ProductListCardCarousel";
import NavBar from "@/components/NavBar";
import PlanetChart from "@/components/PlanetChart";
import VideoPlayer from "@/components/VideoPlayer";

export default {
  name: "ProductDetail",
  metaInfo: {
    title: 'ایوان خانه- جزئیات محصول',
  },
  components: {
    PlanetChart,
    VideoPlayer, NavBar, ProductListCardCarousel
  },
  data: () => ({
    orderNumber: 0,
    commentDescription: '',
    showResult: false,
    reportDescription: null,
    otherReport: false,
    resultText: '',
    rate: null,
    radioGroup: null,
    showLoaderDialog: false,
    openReportSheet: false,
    isContentLoaded: false,
    productInfoStepper: 1,
    items: [
      {
        text: 'دکوراسیون داخلی',
        disabled: false,
        href: 'breadcrumbs_dashboard',
      },
      {
        text: 'مبلمان و صندلی',
        disabled: false,
        href: 'breadcrumbs_link_1',
      },

    ],
    productDetail: {},
    productLoading: true,
    chartActive: false,
    commentsActive: false,
    productBookmarkActive: false,
    openSendCommentSheet: false,
    openCommentSheet: false,
    comments: [],
    similarProducts: [],
    similarProductsLoading: true,
    lastSeen: [],
    gallery: [],
    lastSeenLoading: true,
    productsTips: [],
    selectTips: [],
    select: null,
    productTip: null,
    vendorRates: null,
    productInfo: null,
    breadCrumbItems: [],
    canCopy: false,
    isChartLoaded: false,
    maxPrice: null,
    minPrice: null,
    chartLabel: [],
    chartData: [],
    showChartModal: false,
    userSaved: null


  }),
  mounted() {
    this.getData()
    // this.getChartData()
    this.getProductInfo()


  },
  watch: {
    '$route.query.VendorProductID'() {
      this.getData()
    }
  },
  created() {
    this.canCopy = !!navigator.clipboard;
  },
  methods: {
    checkUserSaveProduct() {
      this.userSaved = this.$store.getters.getUserBookmarks
      let saves = this.userSaved
      let id = this.$route.query.VendorProductID
      if (saves.find(x => x.RelationID === id) !== undefined) {
        this.productBookmarkActive = true
      }
    },
    async copy(s) {
      await navigator.clipboard.writeText(s);
      this.resultText = 'لینک کپی شد.'
      this.showResult = true
    },
    getData() {
      this.showLoaderDialog = true
      let isLoggedIn = this.$store.getters.getIsLoggedIn
      let requestOptions = {
        method: 'GET',
        redirect: 'follow'
      };
      if (isLoggedIn) {
        let myHeaders = new Headers();
        myHeaders.append("Authorization", this.$getUserData().token);
        requestOptions.headers = myHeaders

      }

      fetch(this.$baseUrl + "SearchEngine/SpecialProduct?VendorProductID=" + this.$route.query.VendorProductID, requestOptions)
          .then(response => response.text())
          .then(result => {
            let json = JSON.parse(result)
            let productInfo = json.SearchVendorProductViewModel
            let gallery = json.SearchVendorProductViewModel.VendorProductGalleryViewModels.filter(x => x.IsActive === true)
            gallery.push({TypeStrucGallery: 1, FileUrl: productInfo.FileUrl})
            this.gallery = gallery.reverse()
            this.productDetail = productInfo

            this.productsTips = json.SearchVendorProductViewModel.VendorProductTipViewModels
            let tips = []
            let tipsArr = json.SearchVendorProductViewModel.VendorProductTipViewModels
            for (let i = 0; i < tipsArr.length; i++) {
              tips.push({value: tipsArr[i].VendorProductTipID, text: 'تیپ ' + (i + 1)})
            }
            this.select = tips[0].value
            this.selectTips = tips
            this.initProductType()


            let votes = json.SearchVendorProductViewModel.VoteViewModel
            if (votes.length > 0) {
              let avgVote = votes.length
              let sumVote = 0
              for (let i = 0; i < votes.length; i++) {
                sumVote += votes[i].Rate
              }
              this.vendorRates = this.$roundNum(sumVote / avgVote)

            } else {
              this.vendorRates = 0
            }

            this.comments = json.SearchVendorProductViewModel.VoteViewModel


            let products = json.SimilarProduct
            for (let i = 0; i < products.length; i++) {
              products[i].tip = products[i].VendorProductTipViewModels[0]
              products[i].ProductCategorFileUrl= products[i].VendorLogo
              let voteArr = products[i].VoteViewModel

              let num = voteArr.length
              let sumVote = 0
              for (let j = 0; j < voteArr.length; j++) {
                sumVote += voteArr[j].Rate
              }
              let avg = sumVote / num;
              if (avg > 0) {
                products[i].avgVote = sumVote / num
              } else {
                products[i].avgVote = 0
              }
            }
            this.similarProducts = products
            this.similarProductsLoading = false

            let lastVisit = json.LastVisit

            if (lastVisit !== null && lastVisit.length > 0) {

              for (let i = 0; i < lastVisit.length; i++) {
                lastVisit[i].tip = lastVisit[i].VendorProductTipViewModels[0]

                let voteArr = lastVisit[i].VoteViewModel

                let num = voteArr.length
                let sumVote = 0
                for (let j = 0; j < voteArr.length; j++) {
                  sumVote += voteArr[j].Rate
                }
                let avg = sumVote / num;
                if (avg > 0) {
                  lastVisit[i].avgVote = sumVote / num
                } else {
                  lastVisit[i].avgVote = 0
                }
              }


            }


            this.lastSeen = lastVisit
            this.lastSeenLoading = false
            this.showLoaderDialog = false

            let breadCrumb = json.BreadCrumb.split('#')
            let breadCrumbItems = []
            for (let i = 0; i < breadCrumb.length; i++) {
              breadCrumbItems.push({
                'id': breadCrumb[i].split('@Name=')[0].split('=')[1],
                'name': breadCrumb[i].split('@Name=')[1],
                'arrow': '>'
              })
            }

            this.breadCrumbItems = breadCrumbItems
            this.isContentLoaded = true
            this.checkUserSaveProduct()

          })
          .catch(error => console.log('error', error));


    },
    getProductInfo() {
      let myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

      let urlencoded = new URLSearchParams();
      urlencoded.append("VendorProductID", this.$route.query.VendorProductID);

      let requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: urlencoded,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "CommonMethod/LoadProductCategoryDetialsForShoppingApi", requestOptions)
          .then(response => response.text())
          .then(result => {
            this.productInfo = JSON.parse(result)
          })
          .catch(error => console.log('error', error));
    },
    openSendComments() {
      this.commentsActive = !this.commentsActive
      this.openSendCommentSheet = !this.openSendCommentSheet
    },
    closeCommentsSheet() {
      this.commentsActive = !this.commentsActive
      this.openSendCommentSheet = !this.openSendCommentSheet
    },
    initProductType() {
      let selectedTip = this.selectTips.filter(x => x.text === 'تیپ 1')
      this.productTip = this.productsTips.find(x => x.VendorProductTipID === selectedTip[0].value)
    },
    selectedTip() {
      this.productTip = this.productsTips.find(x => x.VendorProductTipID === this.select)
    },
    registerComment() {
      this.openCommentSheet = false
      this.showLoaderDialog = true
      let myHeaders = new Headers();
      myHeaders.append("Authorization", this.$getUserData().token);
      myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

      let urlencoded = new URLSearchParams();
      urlencoded.append("RelationID", this.$route.query.VendorProductID);
      urlencoded.append("Rate", this.rate);
      urlencoded.append("Description", this.commentDescription);
      urlencoded.append("TypeVote", "1");

      let requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: urlencoded,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "CommonMethod/SetVote", requestOptions)
          .then(response => response.text())
          .then(result => {
            this.showLoaderDialog = false
            this.resultText = result
            this.showResult = true
          })
          .catch(error => console.log('error', error));
    },
    like(id) {
      this.showLoaderDialog = true
      let myHeaders = new Headers();
      myHeaders.append("Authorization", this.$getUserData().token);
      myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

      let urlencoded = new URLSearchParams();
      urlencoded.append("VoteID", id);

      let requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: urlencoded,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "CommonMethod/SetVoteLike", requestOptions)
          .then(response => response.text())
          .then(result => {
            this.showLoaderDialog = false
            this.resultText = result
            this.showResult = true
            this.getData()
          })
          .catch(error => console.log('error', error));
    },
    dislike(id) {
      this.showLoaderDialog = true
      let myHeaders = new Headers();
      myHeaders.append("Authorization", this.$getUserData().token);
      myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

      let urlencoded = new URLSearchParams();
      urlencoded.append("VoteID", id);

      let requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: urlencoded,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "CommonMethod/SetVoteDislike", requestOptions)
          .then(response => response.text())
          .then(result => {
            this.showLoaderDialog = false
            this.resultText = result
            this.showResult = true
            this.getData()
          })
          .catch(error => console.log('error', error));
    },
    getChartData() {
      let myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

      let urlencoded = new URLSearchParams();
      urlencoded.append("VendorProductID", this.$route.query.VendorProductID);

      let requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: urlencoded,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "CommonMethod/_HistoryPriceWithVendorProductApi", requestOptions)
          .then(response => response.text())
          .then(result => {
            let json = JSON.parse(result);
            console.log('json')
            if (json.length === 1) {
              this.chartData = []
              this.chartLabel = []
              this.minPrice = 0
              this.maxPrice = json[0].Price;
              this.chartData.push(json[0].Price);
              this.chartLabel.push(this.$convertDate(json[0].ModifiedDate).toString());
              this.isChartLoaded = true;
            } else {
              this.chartData = []
              this.chartLabel = []
              let prices = []
              for (let i = 0; i < json.length; i++) {
                prices.push(json[i].Price)
                this.chartData.push(json[i].Price);
                console.log('this.chartData', this.chartData)
                this.chartLabel.push(this.$convertDate(json[i].ModifiedDate).toString());
                console.log('this.chartLabel', this.chartLabel)

              }
              this.minPrice = 0
              this.maxPrice = Math.max.apply(Math, prices)
              this.isChartLoaded = true;
            }
          })
          .catch(error => console.log('error', error));
    },
    log() {
      let arr = this.chartData;
      console.log(arr)
      let res = [];
      for (let i = 0; i < arr.length; i++) {
        res.push(arr[i]);
      }
      console.log(res)
      return res;

    },
    log2() {
      let arr = this.chartLabel;
      console.log(arr)
      let res = [];
      for (let i = 0; i < arr.length; i++) {
        res.push(arr[i]);
      }
      console.log(res)
      return res;

    },
    openChartSheet() {
      let myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

      let urlencoded = new URLSearchParams();
      urlencoded.append("VendorProductID", this.$route.query.VendorProductID);

      let requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: urlencoded,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "CommonMethod/_HistoryPriceWithVendorProductApi", requestOptions)
          .then(response => response.text())
          .then(result => {
            let json = JSON.parse(result);
            console.log('json')
            if (json.length === 1) {
              this.chartData = []
              this.chartLabel = []
              this.minPrice = 0
              this.maxPrice = json[0].Price;
              this.chartData.push(json[0].Price);
              this.chartLabel.push(this.$convertDate(json[0].ModifiedDate).toString());
              this.isChartLoaded = true;
              this.showChartModal = true
            } else {
              this.chartData = []
              this.chartLabel = []
              let prices = []
              for (let i = 0; i < json.length; i++) {
                prices.push(json[i].Price)
                this.chartData.push(json[i].Price);
                console.log('this.chartData', this.chartData)
                this.chartLabel.push(this.$convertDate(json[i].ModifiedDate).toString());
                console.log('this.chartLabel', this.chartLabel)
                this.showChartModal = true
              }
              this.minPrice = 0
              this.maxPrice = Math.max.apply(Math, prices)
              this.isChartLoaded = true;
            }
            this.chartActive = !this.chartActive

          })
          .catch(error => console.log('error', error));

    },
    setBookMark() {
      this.showLoaderDialog = true
      let myHeaders = new Headers();
      myHeaders.append("Authorization", this.$getUserData().token);

      let urlencoded = new URLSearchParams();
      urlencoded.append("RelationID", this.$route.query.VendorProductID);
      urlencoded.append("TypeBookMark", "1");

      let requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: urlencoded,
        redirect: 'follow'
      };
      let resStatus = null
      fetch(this.$baseUrl + "CommonMethod/SetBookMark", requestOptions)
          .then(response => {
            resStatus = response.status
            return response.text()
          })
          .then(result => {
            this.showLoaderDialog = false
            if (resStatus === 200) {
              this.productBookmarkActive = !this.productBookmarkActive
              this.$store.commit('addOrRemoveBookmarkItemToList', this.item.VendorProductID)
            }
            this.resultText = result
            this.showResult = true
          })
          .catch(error => console.log('error', error));
    },
    removeFromCart(id) {
      this.showLoaderDialog = true
      let myHeaders = new Headers();
      myHeaders.append("Authorization", this.$getUserData().token);
      myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

      let urlencoded = new URLSearchParams();
      urlencoded.append("ID", id);

      let requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: urlencoded,
        redirect: 'follow'
      };
      let resStatus = null
      fetch(this.$baseUrl + "Shopping/RemoveOrder", requestOptions)
          .then(response => {
            resStatus = response.status
            return response.text()
          })
          .then(result => {
            if (resStatus === 200) {
              let json = JSON.parse(result)
              this.resultText = json.Message
              this.orderNumber = json.NumberNeed
              this.$store.commit('addProductToCart')
            } else {
              this.resultText = result
            }
            this.showLoaderDialog = false
            this.showResult = true
          })
          .catch(error => console.log('error', error));
    },
    minusOrder(id) {
      this.showLoaderDialog = true
      let myHeaders = new Headers();
      myHeaders.append("Authorization", this.$getUserData().token);
      myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

      let urlencoded = new URLSearchParams();
      urlencoded.append("ID", id);

      let requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: urlencoded,
        redirect: 'follow'
      };
      let resStatus = null
      fetch(this.$baseUrl + "Shopping/MinusOrder", requestOptions)
          .then(response => {
            resStatus = response.status
            return response.text()
          })
          .then(result => {
            if (resStatus === 200) {
              let json = JSON.parse(result)
              this.resultText = json.Message
              this.orderNumber = json.NumberNeed

            } else {
              this.resultText = result
            }
            this.showLoaderDialog = false
            this.showResult = true
          })
          .catch(error => console.log('error', error));

    },
    addOrder(id) {
      this.showLoaderDialog = true
      let myHeaders = new Headers();
      myHeaders.append("Authorization", this.$getUserData().token);
      myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

      let urlencoded = new URLSearchParams();
      urlencoded.append("ID", id);


      let requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: urlencoded,
        redirect: 'follow'
      };
      let resStatus = null
      fetch(this.$baseUrl + "Shopping/AddOrder", requestOptions)
          .then(response => {
            resStatus = response.status
            return response.text()
          })
          .then(result => {
            if (resStatus === 200) {
              let json = JSON.parse(result)
              this.resultText = json.Message
              this.orderNumber = json.NumberNeed
              this.$store.commit('addProductToCart')


            } else {
              this.resultText = result
            }
            this.showLoaderDialog = false
            this.showResult = true
          })
          .catch(error => console.log('error', error));
    },
    setOrder(id, numberNeed) {
      this.showLoaderDialog = true
      let myHeaders = new Headers();
      myHeaders.append("Authorization", this.$getUserData().token);
      myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

      let urlencoded = new URLSearchParams();
      urlencoded.append("ID", id);
      urlencoded.append("NumberNeed", numberNeed);

      let requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: urlencoded,
        redirect: 'follow'
      };
      let resStatus = null
      fetch(this.$baseUrl + "Shopping/SetOrder", requestOptions)
          .then(response => {
            resStatus = response.status
            return response.text()
          })
          .then(result => {
            if (resStatus === 200) {

              let json = JSON.parse(result)
              console.log(json)
              this.resultText = json.Message
            } else {
              this.resultText = result
            }
            this.showLoaderDialog = false
            this.showResult = true
          })
          .catch(error => console.log('error', error));
    },
    reportProduct() {
      this.showLoaderDialog = true
      let myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

      let urlencoded = new URLSearchParams();
      urlencoded.append("VendorProductID", this.$route.query.VendorProductID);
      urlencoded.append("Description", this.radioGroup);

      let requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: urlencoded,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "CommonMethod/SetVendorSocialNetworkReportFailure", requestOptions)
          .then(response => response.text())
          .then(result => {
            this.showLoaderDialog = false
            this.openReportSheet = false
            this.resultText = result
            this.showResult = true
          })
          .catch(error => console.log('error', error));
    },
    goToCommentOwner(item){
      if(item.TypeRoleCommentOwner === "Vendor"){
        this.$router.push({path:'StoreProfile',query:{VendorID:item.VendorCommentOwnerId}})
      }else {
        this.$router.push({path:'ProfileInSite',query:{ID:item.AppUserId}})
      }
    },
    goToCommentReplyProfile(){
        this.$router.push({path:'StoreProfile',query:{VendorID:this.productDetail.VendorID}})
    }
  }
}
</script>

